import { createLightTheme, BrandVariants } from "@fluentui/react-components";

// Brand colors from your palette
const brandColors: BrandVariants = {
  10: "#040810", // Very dark blue
  20: "#0c1a2b", // Dark blue
  30: "#133B54", // Blue #2 - Primary brand color
  40: "#1e4a66", // Slightly lighter blue
  50: "#295a79", // Medium blue
  60: "#346a8b", // Medium-light blue
  70: "#4f7fa0", // Light blue
  80: "#6a94b5", // Lighter blue
  90: "#85a9ca", // Very light blue
  100: "#a0bede", // Pale blue
  110: "#bbd3f3", // Very pale blue
  120: "#d6e8ff", // Almost white blue
  130: "#e8f2ff", // Very light tint
  140: "#f4f9ff", // Barely blue tint
  150: "#fafcff", // Almost white
  160: "#ffffff", // White
};

// Create custom theme using your brand colors
export const brandTheme = createLightTheme(brandColors);

// You can also override specific tokens if needed
export const customBrandTheme = {
  ...brandTheme,
  // Override specific tokens for more control
  colorBrandBackground: "#133B54", // Blue #2
  colorBrandBackgroundHover: "#1e4a66",
  colorBrandBackgroundPressed: "#0c1a2b",
  colorBrandForeground1: "#133B54",
  colorBrandForeground2: "#1e4a66",

  // You can add more custom overrides here
  borderRadiusSmall: "4px",
  borderRadiusMedium: "6px",
  borderRadiusLarge: "8px",
};
